<div class="bg-bg-base">
  <section class="relative overflow-hidden py-10">

    <div class="pointer-events-none absolute inset-0 overflow-hidden">
      <div class="absolute -left-40 -top-40 h-80 w-80 rounded-full bg-primary/5 blur-3xl"></div>
      <div class="absolute -bottom-40 -right-40 h-80 w-80 rounded-full bg-primary-deep/10 blur-3xl"></div>
    </div>

    <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

      <div class="flex items-end justify-between mb-10 gap-4">
        <div class="flex-1 min-w-0">
        <h2
          class="mb-3 bg-primary bg-clip-text text-3xl font-bold text-transparent md:text-4xl leading-[2] tracking-tight">
          {{ 'home.projects.title' | translate }}
        </h2>
          <p class="max-w-2xl text-text-secondary text-sm md:text-base">
            {{ 'home.projects.subtitle' | translate }}
          </p>
        </div>

        @if (!isLoading && !errorMessage && projects.length) {
        <div class="flex items-center gap-2 flex-shrink-0 mb-1">
          <button (click)="scrollPrev()" aria-label="Previous"
            class="flex h-10 w-10 items-center justify-center rounded-full border border-border-subtle bg-surface text-text-secondary shadow-sm transition-all hover:border-primary hover:text-primary hover:bg-surface-hover hover:shadow-md active:scale-95 disabled:opacity-50 disabled:pointer-events-none">
            @if (isRtl) {
            <i class="fas fa-chevron-right text-xs"></i>
            } @else {
            <i class="fas fa-chevron-left text-xs"></i>
            }
          </button>
          <button (click)="scrollNext()" aria-label="Next"
            class="flex h-10 w-10 items-center justify-center rounded-full border border-border-subtle bg-surface text-text-secondary shadow-sm transition-all hover:border-primary hover:text-primary hover:bg-surface-hover hover:shadow-md active:scale-95 disabled:opacity-50 disabled:pointer-events-none">
            @if (isRtl) {
            <i class="fas fa-chevron-left text-xs"></i>
            } @else {
            <i class="fas fa-chevron-right text-xs"></i>
            }
          </button>
        </div>
        }
      </div>

      @if (isLoading) {
      <div class="flex justify-center items-center py-20">
        <div class="h-12 w-12 animate-spin rounded-full border-4 border-border-strong border-t-primary"></div>
      </div>
      }

      @if (errorMessage && !isLoading) {
      <div
        class="mx-auto max-w-md rounded-2xl border border-danger/30 bg-danger/10 p-6 text-center shadow-sm backdrop-blur-sm">
        <div class="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-danger/20 text-danger">
          <i class="fas fa-exclamation-circle text-xl"></i>
        </div>
        <p class="text-sm font-medium text-danger mb-4">{{ errorMessage }}</p>
        <button (click)="loadProjects()"
          class="btn btn-danger px-5 py-2 text-sm">
          {{ 'home.projects.retry' | translate }}
        </button>
      </div>
      }

      @if (!isLoading && !errorMessage && projects.length) {
      <div class="overflow-visible px-1 -mx-1"
           (mouseenter)="stopAutoScroll()"
           (mouseleave)="startAutoScroll()">
        <div #scrollTrack class="flex gap-6 overflow-x-auto scroll-smooth pb-6 pt-2 select-none snap-x snap-mandatory"
          style="scrollbar-width: none; -ms-overflow-style: none;">

          @for (project of projects; track project.id) {
          <div class="flex-shrink-0 w-[280px] sm:w-[320px] md:w-[350px] snap-start scroll-ml-4">
            <app-projects-card class="block h-full transition-transform duration-300" [project]="project"
              (projectClick)="onPropertyClick($event)">
            </app-projects-card>
          </div>
          }
        </div>
      </div>
      }

      @if (!isLoading && !errorMessage && projects.length === 0) {
      <div class="mx-auto max-w-md surface-card p-12 text-center">
        <div class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-surface-elevated text-text-muted">
          <i class="fas fa-building text-2xl"></i>
        </div>
        <h3 class="text-text-primary font-semibold text-lg mb-1">{{ 'home.projects.noProjects' | translate }}</h3>
        <p class="text-text-secondary text-sm max-w-sm mx-auto">{{ 'home.projects.noProjectsMessage' | translate }}</p>
      </div>
      }

      @if (!isLoading && !errorMessage && projects.length) {
      <div class="text-center mt-8">
        <a routerLink="/projects">
        <button 
          class="btn btn-primary px-8 py-3.5 text-sm">
          {{ 'home.projects.viewAll' | translate }}
        </button>
        </a>
      </div>
      }

    </div>
  </section>
</div>
